/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs'
import * as Yup from 'yup'

import { TSHIRT_SIZES } from 'constants/models'

const validateTandemField = (value: any, testContext: any) => {
  if (testContext.parent.isTandem)
    if (value !== undefined && value !== null) {
      return value && value.toString().trim().length > 0
    } else return false

  return true
}

const schema = {
  // TANDEM categories
  isTandem: Yup.boolean(),
  tandemAgeRange: Yup.mixed(),
  eventEndDateTime: Yup.mixed(),
  tandemName: Yup.string()
    .test(
      'required-with-tandem',
      'Tandem participant name is required',
      validateTandemField,
    )
    .test(
      'validate',
      'Tandem participant name must not exceed 50 characters',
      (value) => {
        if (value !== undefined && value !== null)
          return /^[a-z ,.'-]{1,50}$/i.test(value.toString())
        return true
      },
    ),
  tandemBirthdate: Yup.mixed()
    .test(
      'required-with-tandem',
      'Tandem participant birthdate is required',
      validateTandemField,
    )
    .test(
      'validate-format',
      'Tandem participant birthdate must be valid date in format YYYY-MM-DD',
      (value) => {
        if (value !== undefined && value !== null)
          return dayjs(value as string, 'YYYY-MM-DD', true).isValid()
        return true
      },
    )
    .test({
      name: 'validate-range',
      test: (value: any, testContext: any) => {
        if (value !== undefined && value !== null) {
          if (
            'tandemAgeRange' in testContext.parent &&
            'eventEndDateTime' in testContext.parent &&
            testContext.parent.tandemAgeRange.length > 0
          ) {
            const bday = dayjs(
              `${value}T23:59:59+08:00`,
              'YYYY-MM-DDTHH:mm:ssZ',
            )
            const eventDay = dayjs(testContext.parent.eventEndDateTime)
            const range = testContext.parent.tandemAgeRange.split('-')
            const ageDuringEvent = eventDay.diff(bday, 'year')
            if (
              ageDuringEvent < parseInt(range[0]) ||
              ageDuringEvent > parseInt(range[1])
            ) {
              return testContext.createError({
                message: `Child birthdate must be in the specified age range ${testContext.parent.tandemAgeRange}`,
                path: testContext.path, // Fieldname
              })
            }
          }
        }
        return true
      },
    })
    .test(
      'validate-future',
      'Child birthdate must not be a future date',
      (value) => {
        if (value !== undefined && value !== null)
          return dayjs().isAfter(value as string)
        return true
      },
    ),
  tandemShirtSize: Yup.mixed()
    .test(
      'required-with-tandem',
      'Tandem participant t-shirt size is required',
      validateTandemField,
    )
    .oneOf(Object.keys(TSHIRT_SIZES)),
}

export default schema
